<template>
  <div class="mt-0" align="center">

  </div>
</template>
<script>
import axios from 'axios'
import { ecomService_dotnet } from '@/website/global'
import { DateNow, FormatInvoice, formatMoney } from '@/website/global_function'
import { header_token } from '@/website/backend/token'
  export default {
    components: {
      // 'barcode': VueBarcode,
      // VueQrcode
    },
    data: () => ({
      shop_id: null,
      url_callback: null
    }),
    async created () {
      this.shop_id = localStorage.getItem('shop_id')
    
      this.url_callback = window.location.href
      if(this.$route.query.url!=null){
        var path = this.$route.query.url.toString();

        window.location.assign(decodeURI(path)+"?code="+this.$route.query.code+"&shop_id="+this.$route.query.shop_id);
      }else{

      
        if(this.shop_id != null){
          await this.update_data_call_back()
        }else {
          // encode fullphat
          var url_encode = encodeURIComponent(this.url_callback)
          this.$router.push('/login?ref='+ url_encode)
        }
      }
    },
    watch: {
    },
    methods: {
      // DateNow,
      async update_data_call_back() {
        this.loading = true
        var bool_check_init_shopee = localStorage.getItem('check_init_shopee')
        var warehouseid = localStorage.getItem('shopee_connect_warehouse')
        var storeCode = localStorage.getItem('storeCode')
        var invoiceAccount = localStorage.getItem('invoiceAccount')
        var inventLocation = localStorage.getItem('inventLocation')
        var shopee_init_timerange = JSON.parse(localStorage.getItem('shopee_init_timerange'))
        if(bool_check_init_shopee == 'false'){
          bool_check_init_shopee = false
        } else if (bool_check_init_shopee == 'true') {
          bool_check_init_shopee = true
        }
        var synnex_ischeckcost = localStorage.getItem('synnex_ischeckcost')
        if (synnex_ischeckcost === 'true') synnex_ischeckcost = true
        else if (synnex_ischeckcost === 'false') synnex_ischeckcost = false
        else synnex_ischeckcost = null
        let response1 = await axios.post(ecomService_dotnet+'Shopee/callback',{
          "shopID": this.shop_id ,
          "isInit": bool_check_init_shopee,
          "warehouseID":warehouseid,
          "callbackUrl": this.url_callback,
          "initTimeRanges":shopee_init_timerange,
          "inventLocation": inventLocation,
          "invoiceAccount": invoiceAccount,
          'storeCode': storeCode,
          "synnex_ischeckcost": synnex_ischeckcost
        } , { headers: header_token})
        this.loading = false
        localStorage.removeItem("check_init_shopee");
        localStorage.removeItem("shopee_connect_warehouse");
        localStorage.removeItem("shopee_init_timerange");
        localStorage.removeItem("storeCode");
        localStorage.removeItem("invoiceAccount");
        localStorage.removeItem("inventLocation");
        localStorage.removeItem("synnex_ischeckcost");
        this.$router.push('/connect')
        
      },

      // async update_data_connect () {
      //   let response = await axios.post(shopCallbackService+'shopee/update_data_monthlyfee', {
      //     'shop_id': localStorage.getItem('shop_id'),
      //     'staff_id' : localStorage.getItem('staff_id'),
      //     'branch_id' : localStorage.getItem('branch_id')
      //   })
      //   if (response.data.status == 'Success') {
      //     // console.log('end');
      //     console.log('update monthlyfee success');
      //   }
      //   this.loading = false
      // },
    },
  }
</script>
